// Pure fold of a replay's event stream up to (and including) `uptoIndex` into a lightweight board
// state — the community cards on the felt and the running pot. This is the "board-state strip
// derived by folding events up to the current step" (no full table re-render in v1). Shared with
// the replay window and unit-tested independently.
//
// Sources: STREET_ADVANCED.board is the authoritative board for that street; a COMMUNITY
// CARD_MODIFIED rewrites one board index; the running pot is the latest numeric `pot` seen on any
// event (STREET_ADVANCED / PLAYER_ACTION carry it). POT_AWARD carries `amount`, not `pot`, so it
// does not change the running pot.
export const foldBoardState = (events, uptoIndex) => {
  let board = [];
  let pot = 0;
  if (!Array.isArray(events) || events.length === 0) return { board, pot };
  const end = Math.min(uptoIndex, events.length - 1);
  for (let i = 0; i <= end; i++) {
    const e = events[i];
    if (!e) continue;
    const p = e.payload || {};
    if (e.type === 'STREET_ADVANCED') {
      board = String(p.board || '').trim().split(/\s+/).filter(Boolean);
    } else if (e.type === 'CARD_MODIFIED' && p.zone === 'COMMUNITY'
        && Number.isInteger(p.index) && p.after && p.index >= 0 && p.index < board.length) {
      board = board.map((c, idx) => (idx === p.index ? p.after : c));
    }
    if (typeof p.pot === 'number') pot = p.pot;
  }
  return { board, pot };
};

export default foldBoardState;
